// import React, { Component } from 'react';
// import { Card } from 'react-bootstrap';
// import { Helmet } from 'react-helmet';
// import { Breadcrumb } from '@gull';
// import { Formik } from 'formik';
// import { model, validationModel } from './AddBankModel';
// import bankService from 'app/services/bankService';
// import history from '@history.js';
// import './AddBank.css';

// const { addBank } = bankService;

// class AddBank extends Component {
//   state = {
//     model,
//   };
//   addNewBank = async (values) => {
//     const data = await addBank(values);
//     if (data && data.status === 'Success') {
//       history.push('/distributor/bank/bank-lists');
//     } else {
//       console.log(data);
//     }
//   };

//   render() {
//     return (
//       <div>
//         <Helmet>
//           <title>Add New Bank</title>
//         </Helmet>

//         <Breadcrumb
//           routeSegments={[
//             { name: 'Bank Lists', path: '/distributor/bank/bank-lists' },
//             { name: 'Add New Bank' },
//           ]}
//         ></Breadcrumb>

//         <Card className='m-auto pl-4 pt-4' style={{ width: '90%' }}>
//           <Formik
//             initialValues={this.state.model}
//             validationSchema={validationModel}
//             onSubmit={this.addNewBank}
//           >
//             {({
//               values,
//               errors,
//               touched,
//               handleChange,
//               handleBlur,
//               handleSubmit,
//               isSubmitting,
//               isValid,
//               dirty,
//             }) => {
//               return (
//                 <form onSubmit={handleSubmit}>
//                   <div
//                     className='row'
//                     style={{ alignItems: 'center', paddingLeft: '14px' }}
//                   >
//                     <div className='col-md-6 col-12'>
//                       <div className='form-group'>
//                         <label
//                           htmlFor='bankName'
//                           className='font-weight-bold'
//                           style={{ fontSize: '15px' }}
//                         >
//                           Bank Name
//                           <span className='text-danger'> *</span>
//                         </label>
//                         <input
//                           type='text'
//                           name='bankName'
//                           id='bankName'
//                           className={
//                             touched.bankName && errors.bankName
//                               ? 'error form-control customInput'
//                               : 'form-control customInput'
//                           }
//                           placeholder='Bank Name'
//                           value={values.bankName}
//                           error={errors.bankName}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.bankName}
//                         />
//                         <p className='text-danger'>
//                           {touched.bankName && errors.bankName}
//                         </p>
//                       </div>
//                     </div>
//                     <div className='col-md-6 col-12'>
//                       <div className='form-group'>
//                         <label
//                           htmlFor='accountNumber'
//                           className='font-weight-bold'
//                           style={{ fontSize: '15px' }}
//                         >
//                           A/C Number
//                           <span className='text-danger'> *</span>
//                         </label>
//                         <input
//                           type='text'
//                           name='accountNumber'
//                           id='accountNumber'
//                           className={
//                             touched.accountNumber && errors.accountNumber
//                               ? 'error form-control customInput'
//                               : 'form-control customInput'
//                           }
//                           placeholder='Account Number'
//                           value={values.accountNumber}
//                           error={errors.accountNumber}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.accountNumber}
//                         />
//                         <p className='text-danger'>
//                           {touched.accountNumber && errors.accountNumber}
//                         </p>
//                       </div>
//                     </div>
//                   </div>

//                   <div
//                     className='row'
//                     style={{ alignItems: 'center', paddingLeft: '14px' }}
//                   >
//                     <div className='col-md-6 col-12'>
//                       <div className='form-group'>
//                         <label
//                           htmlFor='ifscCode'
//                           className='font-weight-bold'
//                           style={{ fontSize: '15px' }}
//                         >
//                           IFSC Code
//                           <span className='text-danger'> *</span>
//                         </label>
//                         <input
//                           type='text'
//                           name='ifscCode'
//                           id='ifscCode'
//                           className={
//                             touched.ifscCode && errors.ifscCode
//                               ? 'error form-control customInput'
//                               : 'form-control customInput'
//                           }
//                           placeholder='IFSC Code'
//                           value={values.ifscCode}
//                           error={errors.ifscCode}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.ifscCode}
//                         />
//                         <p className='text-danger'>
//                           {touched.ifscCode && errors.ifscCode}
//                         </p>
//                       </div>
//                     </div>
//                     <div className='col-md-6 col-12'>
//                       <div className='form-group'>
//                         <label
//                           htmlFor='branch'
//                           className='font-weight-bold'
//                           style={{ fontSize: '15px' }}
//                         >
//                           Branch
//                           <span className='text-danger'> *</span>
//                         </label>
//                         <input
//                           type='text'
//                           name='branch'
//                           id='branch'
//                           className={
//                             touched.branch && errors.branch
//                               ? 'error form-control customInput'
//                               : 'form-control customInput'
//                           }
//                           placeholder='Branch'
//                           value={values.branch}
//                           error={errors.branch}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.branch}
//                         />
//                         <p className='text-danger'>
//                           {touched.branch && errors.branch}
//                         </p>
//                       </div>
//                     </div>
//                   </div>

//                   <div
//                     className='row'
//                     style={{ alignItems: 'center', paddingLeft: '14px' }}
//                   >
//                     <div className='col-md-6 col-12'>
//                       <div className='form-group'>
//                         <label
//                           htmlFor='shortCode'
//                           className='font-weight-bold'
//                           style={{ fontSize: '15px' }}
//                         >
//                           Bank Short Code
//                           <span className='text-danger'> *</span>
//                         </label>
//                         <input
//                           type='text'
//                           name='shortCode'
//                           id='shortCode'
//                           className={
//                             touched.shortCode && errors.shortCode
//                               ? 'error form-control customInput'
//                               : 'form-control customInput'
//                           }
//                           placeholder='Bank Short Code'
//                           value={values.shortCode}
//                           error={errors.shortCode}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.shortCode}
//                         />
//                         <p className='text-danger'>
//                           {touched.shortCode && errors.shortCode}
//                         </p>
//                       </div>
//                     </div>
//                     <div className='col-md-6 col-12'>
//                       <div className='form-group'>
//                         <label
//                           htmlFor='swiftCode'
//                           className='font-weight-bold'
//                           style={{ fontSize: '15px' }}
//                         >
//                           Swift Code
//                           <span className='text-danger'> *</span>
//                         </label>
//                         <input
//                           type='text'
//                           name='swiftCode'
//                           id='swiftCode'
//                           className={
//                             touched.swiftCode && errors.swiftCode
//                               ? 'error form-control customInput'
//                               : 'form-control customInput'
//                           }
//                           placeholder='Swift Code'
//                           value={values.swiftCode}
//                           error={errors.swiftCode}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.swiftCode}
//                         />
//                         <p className='text-danger'>
//                           {touched.swiftCode && errors.swiftCode}
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     className='row'
//                     style={{ alignItems: 'center', paddingLeft: '14px' }}
//                   >
//                     <div className='col-md-6 col-12'>
//                       <div className='form-group'>
//                         <label
//                           htmlFor='address'
//                           className='font-weight-bold'
//                           style={{ fontSize: '15px' }}
//                         >
//                           Address
//                           <span className='text-danger'> *</span>
//                         </label>
//                         <input
//                           type='text'
//                           name='address'
//                           id='address'
//                           className={
//                             touched.address && errors.address
//                               ? 'error form-control customInput'
//                               : 'form-control customInput'
//                           }
//                           placeholder='Address'
//                           value={values.address}
//                           error={errors.address}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.address}
//                         />
//                         <p className='text-danger'>
//                           {touched.address && errors.address}
//                         </p>
//                       </div>
//                     </div>
//                     <div className='col-md-6 col-12'>
//                       <div className='form-group'>
//                         <label
//                           htmlFor='remarks'
//                           className='font-weight-bold'
//                           style={{ fontSize: '15px' }}
//                         >
//                           Remarks
//                         </label>
//                         <input
//                           type='text'
//                           name='remarks'
//                           id='remarks'
//                           className={
//                             touched.remarks && errors.remarks
//                               ? 'error form-control customInput'
//                               : 'form-control customInput'
//                           }
//                           placeholder='Remarks'
//                           value={values.remarks}
//                           error={errors.remarks}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.remarks}
//                         />
//                         <p className='text-danger'>
//                           {touched.remarks && errors.remarks}
//                         </p>
//                       </div>
//                     </div>
//                   </div>

//                   <div
//                     className='row'
//                     style={{ alignItems: 'center', paddingLeft: '14px' }}
//                   >
//                     <div className='col-md-6 col-12'>
//                       <div className='form-group'>
//                         <label
//                           htmlFor='status'
//                           className='font-weight-bold'
//                           style={{ fontSize: '15px' }}
//                         >
//                           Status
//                         </label>
//                         <div className='custom-control custom-switch'>
//                           <input
//                             type='checkbox'
//                             name='status'
//                             id='status'
//                             className='custom-control-input'
//                            // id='status'
//                             value={values.status}
//                             error={errors.status}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             // touched={touched.status}
//                           />

//                           <label
//                             className='custom-control-label'
//                             htmlFor='status'
//                           >
//                             Active
//                           </label>
//                         </div>
//                       </div>
//                     </div>

//                     <div className='col-12 mt-3 mb-3'>
//                       <button type='submit' className='btn btn-primary'>
//                         Submit
//                       </button>
//                     </div>
//                   </div>
//                 </form>
//               );
//             }}
//           </Formik>
//         </Card>
//       </div>
//     );
//   }
// }

// export default AddBank;

import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Breadcrumb } from "@gull";
import { Formik } from "formik";
import { model, validationModel } from "./AddBankModel";
import { addBank } from "app/services/AdminServices/bankService";
import { useNavigate } from "react-router-dom";
import "./AddBank.css";

const AddBank = () => {
  const [state, setState] = useState({
    model,
  });

  const navigate = useNavigate();

  const addNewBank = async (values) => {
    const data = await addBank(values);
    if (data && data.status === "Success") {
      navigate("/distributor/bank/bank-lists");
    } else {
      console.log(data);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Add New Bank</title>
      </Helmet>

      <Breadcrumb
        routeSegments={[
          { name: "Bank Lists", path: "/admin/bank/bank-lists" },
          { name: "Add New Bank" },
        ]}
      ></Breadcrumb>

      <Card className="pt-4 mb-3">
        <Card.Body>
          <Formik
            initialValues={state.model}
            validationSchema={validationModel}
            onSubmit={addNewBank}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
            }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 col-12 float-end">
                      <div className="form-group">
                        <label
                          htmlFor="bankName"
                          className=" fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Bank Name
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="bankName"
                          id="bankName"
                          className={
                            touched.bankName && errors.bankName
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Bank Name"
                          value={values.bankName}
                          error={errors.bankName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.bankName && errors.bankName}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="accountNumber"
                          className=" fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          A/C Number
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="accountNumber"
                          id="accountNumber"
                          className={
                            touched.accountNumber && errors.accountNumber
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Account Number"
                          value={values.accountNumber}
                          error={errors.accountNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.accountNumber && errors.accountNumber}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="ifscCode"
                          className=" fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          IFSC Code
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="ifscCode"
                          id="ifscCode"
                          className={
                            touched.ifscCode && errors.ifscCode
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="IFSC Code"
                          value={values.ifscCode}
                          error={errors.ifscCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.ifscCode && errors.ifscCode}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="branch"
                          className=" fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Branch
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="branch"
                          id="branch"
                          className={
                            touched.branch && errors.branch
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Branch"
                          value={values.branch}
                          error={errors.branch}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.branch && errors.branch}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="shortCode"
                          className=" fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Bank Short Code
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="shortCode"
                          id="shortCode"
                          className={
                            touched.shortCode && errors.shortCode
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Bank Short Code"
                          value={values.shortCode}
                          error={errors.shortCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.shortCode && errors.shortCode}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="swiftCode"
                          className=" fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Swift Code
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="swiftCode"
                          id="swiftCode"
                          className={
                            touched.swiftCode && errors.swiftCode
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Swift Code"
                          value={values.swiftCode}
                          error={errors.swiftCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.swiftCode && errors.swiftCode}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="address"
                          className=" fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Address
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="address"
                          id="address"
                          className={
                            touched.address && errors.address
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Address"
                          value={values.address}
                          error={errors.address}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.address && errors.address}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="remarks"
                          className=" fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Remarks
                        </label>
                        <input
                          type="text"
                          name="remarks"
                          id="remarks"
                          className={
                            touched.remarks && errors.remarks
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Remarks"
                          value={values.remarks}
                          error={errors.remarks}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.remarks && errors.remarks}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckDefault"
                          // //
                          name="status"
                          value={values.status}
                          error={errors.status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <label
                          class="form-check-label"
                          for="flexSwitchCheckDefault"
                        >
                          Active
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              );
            }}
          </Formik>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AddBank;
